import { CircleButton } from "_c/button";
import styled from "styled-components";
import { ActiveDiscount } from "_c/modules/profile/common/Service/styled";
import { Price } from "_c/modules/profile/common/Service/styled";
import {
  TitleAndDiscountWrap as TitleAndDiscountWrap_,
  Info as Info_,
} from "_c/modules/profile/common/Service/styled";
export {
  Title,
  Unit,
  Duration,
  Price,
  DescLabel,
  ActiveDiscount,
  PriceUnitDelim,
} from "_c/modules/profile/common/Service/styled";

export const Wrap = styled.div`
  color: var(--font-color-accent);
  padding: 10px;
  display: flex;
  justify-content: space-between;
  position: relative;
  outline: none;
  border-bottom: ${({ theme }) => theme.border.light};
  :last-child {
    border-bottom: none;
  }
  @media (max-width: 550px) {
    flex-direction: column;
    margin-bottom: 10px;
    margin-left: 0;
    padding: 10px;
  }
`;
export const Info = styled(Info_)`
  @media (max-width: 550px) {
    justify-content: flex-start;
    margin-bottom: 5px;
  }
`;
export const TitleAndDiscountWrap = styled(TitleAndDiscountWrap_)`
  @media (max-width: 550px) {
    justify-content: flex-start;
  }
`;

export const OldPrice = styled(Price)`
  opacity: 0.35;
  color: var(--font-color-accent);
  margin-inline-end: 7px;
`;
export const LeftPart = styled.div`
  display: flex;
  position: relative;
`;
export const RightPart = styled.div`
  display: flex;
  align-items: center;
`;
export const DiscountInput = styled.button`
  width: 30px;
  height: 30px;
  text-align: center;
  margin: 0 8px;
  padding: 0;
  border: none;
  box-shadow: 0 7px 30px rgba(127, 124, 104, 0.3);
  color: var(--color-primary);
  font-size: 22px;
  font-weight: 700;
  border-radius: 50%;
  background-color: white;
`;

export const ShopButton = styled(CircleButton).attrs({
  primaryNoGrad: true,
})`
  svg {
    margin-bottom: 1px;
  }
`;
export const DiscountsWrap = styled.div`
  display: flex;
  ${ActiveDiscount} {
    margin: 0 3px;
  }
`;
